import { ISalary, Salary } from '../../entities/salary';
import { IOtherField } from '../../interfaces/other-field.interface';
import * as moment from 'moment';
import { VacancyHelpers } from '../../../helpers/vacancyHelper';

const helpers = VacancyHelpers;

export interface ITableVacancyRes {
  count: any;
  pages: number;
  data: ITableVacancy[];
}

export interface ITableVacancyData {
  count?: any;
  pages: number;
  vacancies: TableVacancy[];
}

export interface ITableVacancy {
  id?: number;
  _id?: string;
  offer_status?: number;
  full_crew: boolean;
  user_id?: {
    _id: string;
    role: number;
    employer_company: {
      name: string;
      photo: string;
    };
  };
  job?: {
    id: {
      _id: string;
      name: string;
    };
    other: boolean;
    value: string;
  };
  logo?: number;
  company_name?: string;
  company_photo?: string;
  position?: IOtherField;
  vessel_type?: {
    name: string;
  };
  salary?: ISalary;
  contract_duration?: string;
  working_location?: string[];
  preferrer_citizenship?: string[];
  join_date?: Date;
  role_type?: number;
}

export class TableVacancy {
  id: number;
  _id: string;
  status: number;
  full_crew: boolean;
  logo: number;
  company_name: string;
  company_photo: string;
  position: IOtherField;
  vessel_type: string;
  salary: Salary;
  duration: string;
  location: string[];
  job: string;
  citizenship: string[];
  sign_on_in: Date;
  role_type: number;
  formatedSignOnIn?: number;
  user_id?: any;

  constructor(data: ITableVacancy) {
    if (!data.user_id) {
      return null;
    }
    this.full_crew = data.full_crew;
    this.user_id = data.user_id._id;
    this.company_name = data.user_id.employer_company.name;
    this.company_photo = data.user_id.employer_company.photo || '';
    this.role_type = data.user_id.role;
    this.id = data.id;
    this._id = data._id;
    this.job = data.job.value;
    this.status = data.offer_status;
    this.logo = data.role_type;
    this.position = data.position;
    this.vessel_type = data.vessel_type.name;
    this.salary = new Salary(data.salary);
    this.duration = data.contract_duration;
    this.location = data.working_location;
    this.citizenship = data.preferrer_citizenship;
    this.sign_on_in = data.join_date;
    this.formatedSignOnIn = helpers.daysRemainingToDate(this.sign_on_in);
  }
}



// WEBPACK FOOTER //
// ./app/core/services/vacancy/table-vacancy.ts